import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FaUser } from 'react-icons/fa';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import UsersTable from './users/UsersTable';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import { useItems } from '../../hooks/atoms/items-hook';
import AppLoader from '../basic/AppLoader';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const Users = () => {
  const {
    items: users,
    itemsLoading: usersLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.ADMIN_TOOL_USERS);

  const classes = useStyles();

  if (usersLoading) {
    return <AppLoader />;
  }

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <FaUser
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Users'
          subtitle={ users !== undefined ? `Entries: ${ totalEntries }` : '' }
          actions={ <></> }
        />
      </div>
      <UsersTable />
    </div>
  );
};

export default Users;

